const PurchaseError = {
  DuplicateProduct: "DuplicateProduct",
  ExistProduct: "ExistProduct",
  UserNoProduct: "UserNoProduct",
  PackageLevelSame: "PackageLevelSame",
  SamePackageLevelHigher: "SamePackageLevelHigher",
  SamePackageLevelLower: "SamePackageLevelLower",
  DifferentPackage: "DifferentPackage"
}
export default PurchaseError
